import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { SharedDataStore } from '../store';

export const validYearGuard: CanActivateFn = async (route) => {
  const router = inject(Router);
  const sharedDataStore = inject(SharedDataStore);

  const yearParam = route.paramMap.get('year');
  const attemptedUrl = location.href;

  if (!yearParam) {
    await router.navigateByUrl('/404', {
      state: { attemptedUrl },
    });
    return false;
  }

  const years = await firstValueFrom(sharedDataStore.priceListYears$);
  const validYears = years.map(({ year }) => year);

  if (!validYears.includes(yearParam)) {
    await router.navigateByUrl('/404', {
      state: { attemptedUrl },
    });
    return false;
  }

  return true;
};
